import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import Boton from "./Boton";
import { clBasic, Scrudo, sizeCelda, sizeEtiqueta } from "./general"

export default function CRUDroles() {
  let { firebase } = useContext(AppContext);

  const [rol, setRol] = useState("Administrador");
  const [permisos, setPermisos] = useState(firebase.permisos(rol));
  const [nuevoRol, setNuevoRol] = useState("");
  const [change, setChange] = useState(false);

  useEffect(() => {
    setPermisos(firebase.permisos(rol));
  }, [rol, firebase]);

  function actualizarRol() {
    if (rol === "...nuevo") {
      if (nuevoRol !== "") {
        permisos.rol = nuevoRol;
        firebase.actualizarRol(nuevoRol, permisos);
        setRol(nuevoRol);
        setNuevoRol("");
      } else alert("Ingrese el nombre del nuevo rol");
    } else firebase.actualizarRol(rol, permisos);
    setChange(false)
  }

  return (
    <div style={Sroles}>
      <div style={Srol}>
        <select
          value={rol}
          style={Sselect}
          onChange={(e) => {
            e.persist();
            setRol(e.target.value);
          }}
        >
          {Object.keys(firebase.dataRoles).map((r, i) => (
            <option key={i} value={r}>
              {r}
            </option>
          ))}
          <option key={99} value={"...nuevo"}>
            ...nuevo
          </option>
        </select>
        {rol === "...nuevo" && (
          <input
            type="text"
            style={SInputR}
            value={nuevoRol}
            onChange={(e) => {
              e.persist(); setChange(true);
              setNuevoRol(e.target.value);
            }}
          ></input>
        )}
      </div>

      <div style={Scrudo}>
        <div style={Sgrupos}>
          <div style={Sgrupo}>
            <div style={Stitulo}>General</div>
            <div style={SDataEntry}>
              <div style={SEtiqueta}>Administración general:</div>
              <input
                type="checkbox"
                checked={permisos.administracion}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, administracion: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Registro de horas a un tercero:</div>
              <input
                type="checkbox"
                checked={permisos.registroHoras}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, registroHoras: e.target.checked }));
                }}
              ></input>
            </div>
          </div>
          <div style={Sgrupo}>
            <div style={Stitulo}>Proyectos</div>
            <div style={SDataEntry}>
              <div style={SEtiqueta}>Alta de Proyectos:</div>
              <input
                type="checkbox"
                checked={permisos.altaProyecto}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, altaProyecto: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Modificación de proyectos propios:</div>
              <input
                type="checkbox"
                checked={permisos.modificarProyectoPropio}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, modificarProyectoPropio: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Modificación de proyectos ajenos:</div>
              <input
                type="checkbox"
                checked={permisos.modificarProyectoAjeno}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, modificarProyectoAjeno: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Alta de Cambios:</div>
              <input
                type="checkbox"
                checked={permisos.altaCambio}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, altaCambio: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Alta de Riesgos:</div>
              <input
                type="checkbox"
                checked={permisos.altaRiesgo}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, altaRiesgo: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Eliminar adjuntos:</div>
              <input
                type="checkbox"
                checked={permisos.eliminarAdjunto}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, eliminarAdjunto: e.target.checked }));
                }}
              ></input>
            </div>
          </div>
          <div style={Sgrupo}>
            <div style={Stitulo}>Incidentes</div>
            <div style={SDataEntry}>
              <div style={SEtiqueta}>Alta de incidentes:</div>
              <input
                type="checkbox"
                checked={permisos.altaIncidente}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, altaIncidente: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Actualizar incidentes ajenos :</div>
              <input
                type="checkbox"
                checked={permisos.actualizarIncidenteAjeno}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, actualizarIncidenteAjeno: e.target.checked }));
                }}
              ></input>
              <div style={SEtiqueta}>Planificar incidentes:</div>
              <input
                type="checkbox"
                checked={permisos.planificarIncidentes}
                style={SInput}
                onChange={(e) => {
                  e.persist(); setChange(true);
                  setPermisos((p) => ({ ...p, planificarIncidentes: e.target.checked }));
                }}
              ></input>
            </div>
          </div>
        </div>
      </div>
      <Boton accion={actualizarRol} change={change} />
    </div>
  );
}

const Sroles = {
  margin: "30px 0px 0px 30px",
  width: "90vw",
};

const Srol = {
  display: "flex",
  flexDirection: "row",
  marginBottom: "10px",
};

const Sgrupos = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  margin: "20px 0px 20px 0px",
};

const Sgrupo = {
  border: `solid 2px ${clBasic}`,
  borderRadius: "5px",
  padding: "15px",
  background: "#e6e6e6",
};

const Stitulo = {
  fontSize: "2.6vh",
  fontWeight: 800,
  margin: "auto",
  borderBottom: `solid 2px ${clBasic}`,
  color: clBasic,
};

const SDataEntry = {
  display: "grid",
  gridTemplateColumns: "95% 5%",
  marginTop: "30px",
};

const SEtiqueta = {
  minWidth: "20vw",
  padding: "6px 0px 6px 6px",
  fontSize: sizeEtiqueta,
  fontWeight: "300",
  color: clBasic,
  margin: "3px 3px 5px 0px",
  borderRadius: "5px",
};

const SInputR = {
  padding: "6px 0px 6px 2px",
  fontSize: sizeCelda,
  borderRadius: "5px",
  background: "#e6e6e6",
  width: "15vw",
};

const Sselect = {
  padding: "6px 0px 6px 2px",
  fontSize: "2.4vh",
  marginRight: "15px",
  borderRadius: "5px",
  background: "#e6e6e6",
  width: "15vw",
};

const SInput = {
  marginTop: "12px"
}

